import React from 'react';

const ItalicIcon = props => (
  <svg viewBox="0 0 10 14" {...props}>
    <path
      stroke="none"
      fillRule="evenodd"
      d="M122.1,66l-0.641,2.482h1.437l-2.836,8.966h-1.423L118,80h6.054l0.634-2.552h-1.527l2.826-8.966h1.372L128,66H122.1Z"
      transform="translate(-118 -66)"
    />
  </svg>
);

export default ItalicIcon;



// WEBPACK FOOTER //
// ./app/components/text-editor/icons/italic-icon.js